// eslint-disable-next-line no-restricted-imports -- this an exception for axios import
import axios from 'axios';

import { CANCEL_FETCH_MESSAGE } from 'hb-react/shared/constants/cancelFetch';

import fetchRequest from './fetchRequest';
import type { FetchResponseProps } from './types';

export default ({
  cancelTokenRef,
  isFetching,
  URLs,
}): Promise<FetchResponseProps[]> => {
  if (isFetching && cancelTokenRef.current) {
    cancelTokenRef.current.cancel(CANCEL_FETCH_MESSAGE);
  }

  const { CancelToken } = axios;

  cancelTokenRef.current = CancelToken.source();

  const requests = URLs.map((URL) =>
    fetchRequest(URL, cancelTokenRef?.current),
  );

  return axios.all(requests);
};
